import { call, put, select, takeLatest } from "redux-saga/effects";
import api from "../../utils/api";
import * as actions from "./actions";
import * as types from "./constants";
import { errorAlert } from "../Alerts/actions";

function* fetchOnboardingQueueSaga(action) {
  const url = `/api/resident/${action.payload?.residentId}/onboarding-queue`;
  try {
    const token = yield select((state) => state?.AuthReducer?.token);
    const { residentId } = action.payload;

    const { data } = yield call(api(token).get, url);

    const result = data?.data || data;
    yield put(actions.fetchOnboardingQueueSuccess(result));
    if (action.callback) action.callback(result);
  } catch (error) {
    yield put(actions.fetchOnboardingQueueFailure(error.message));
    yield put(errorAlert("Failed to load onboarding queue"));
  }
}

function* dismissQueueItemSaga(action) {
  try {
    const token = yield select((state) => state?.AuthReducer?.token);
    const { residentId, templateId, reason, reasonText } = action.payload;

    const body = { template_id: templateId, reason };
    if (reasonText && reasonText.trim()) {
      body.reason_text = reasonText.trim();
    }
    // "Accepted — baseline": record a durable per-resident baseline so the
    // concern isn't re-suggested (the template is also dismissed as usual).
    if (reason === "accepted_baseline") {
      body.set_as_baseline = true;
    }

    const { data } = yield call(
      api(token).post,
      `/api/resident/${residentId}/onboarding-queue/dismiss`,
      body,
    );

    const result = data?.data || data;
    yield put(actions.dismissQueueItemSuccess(result));
    if (action.callback) action.callback(result);
  } catch (error) {
    yield put(actions.dismissQueueItemFailure(error.message));
    yield put(errorAlert("Failed to dismiss template"));
  }
}

function* restoreQueueItemSaga(action) {
  try {
    const token = yield select((state) => state?.AuthReducer?.token);
    const { residentId, templateId } = action.payload;

    const { data } = yield call(
      api(token).post,
      `/api/resident/${residentId}/onboarding-queue/restore`,
      { template_id: templateId },
    );

    const result = data?.data || data;
    yield put(actions.restoreQueueItemSuccess(result));
    if (action.callback) action.callback(result);
  } catch (error) {
    yield put(actions.restoreQueueItemFailure(error.message));
    yield put(errorAlert("Failed to restore template"));
  }
}

function* fetchTemplateGovernanceSaga(action) {
  try {
    const token = yield select((state) => state?.AuthReducer?.token);
    const { residentId, templateId } = action.payload;

    const { data } = yield call(
      api(token).get,
      `/api/resident/${residentId}/template/${templateId}/governance-items`,
    );

    const result = data?.data || [];
    yield put(actions.fetchTemplateGovernanceSuccess(result));
    if (action.callback) action.callback(result);
  } catch (error) {
    yield put(actions.fetchTemplateGovernanceFailure(error.message));
  }
}

export default function* onboardingBuilderSaga() {
  yield takeLatest(types.FETCH_ONBOARDING_QUEUE, fetchOnboardingQueueSaga);
  yield takeLatest(types.DISMISS_QUEUE_ITEM, dismissQueueItemSaga);
  yield takeLatest(types.RESTORE_QUEUE_ITEM, restoreQueueItemSaga);
  yield takeLatest(
    types.FETCH_TEMPLATE_GOVERNANCE,
    fetchTemplateGovernanceSaga,
  );
}
